<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-05 09:20:54
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-05 09:44:20
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\otherItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class='other-item'>
        <div class="left">
            <div class="other-item-title">{{ title }}</div>
            <div class="other-item-desc">{{ desc }}</div>
        </div>
        <Upload bgImg="https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/faceFont.png" :type="type" :img="img" @upload="uploadImg" width="166px" height="102px" />

    </div>
</template>

<script>
import Upload from "./uploadImg.vue"
export default {
    name: 'OtherItem',
    components: { Upload },
    props: {
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        img: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        uploadImg(val) {
            console.log("other", val);
            this.$emit('upload', val)
        }
    },
};
</script>

<style scoped lang="scss">
.other-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 132px;
    padding: 15px;
    margin: 10px 0;
    background: #F7F8FA;
    border-radius: 12px;
    box-sizing: border-box;

    .left {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 138px;

        .other-item-title {
            font-weight: 600;
            font-size: 18px;
            color: #333333;
        }

        .other-item-desc {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
        }
    }
}
</style>
